import React from 'react';

import { Row, Col } from 'components/layout';
import { Title, Text } from 'components/Text';

const ScheduleStepTitle = ({ title, description, ...rest }) => (
  <Row {...rest}>
    <Col span={24}>
      <Row justify="center" align="top">
        <Title level={2}>{title}</Title>
      </Row>
      <Row justify="center">
        <Col span={18} style={{ textAlign: 'center' }}>
          <Text style={{ color: '#828C94' }}>
            {description}
          </Text>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default ScheduleStepTitle;
